import { render, staticRenderFns } from "./RequestProcessM.vue?vue&type=template&id=6ffbcfd4&scoped=true&"
import script from "./RequestProcessM.vue?vue&type=script&lang=js&"
export * from "./RequestProcessM.vue?vue&type=script&lang=js&"
import style0 from "./RequestProcessM.vue?vue&type=style&index=0&id=6ffbcfd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffbcfd4",
  null
  
)

export default component.exports